import { create } from 'zustand';

const useFeedbackStore = create((set, get) => ({
  messages: [],
  seenMessages: new Set(),
  isHistoryVisible: false, // <-- NUEVO ESTADO

  addFeedback: (msg) => set((state) => ({
    messages: [...state.messages, msg]
  })),

  clearFeedback: () => set({ messages: [] }),

  // --- NUEVA ACCIÓN ---
  toggleHistory: () => set((state) => ({ isHistoryVisible: !state.isHistoryVisible })),

  hasSeenMessage: (message) => {
    return get().seenMessages.has(message);
  },

  markMessageAsSeen: (message) => {
    const seen = new Set(get().seenMessages);
    seen.add(message);
    set({ seenMessages: seen });
  },
}));

export default useFeedbackStore;